import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { ReactNode, useState } from 'react';
import { PageInfoCard } from './PageInfoCard';
import './PageTitle.css';

type PageTitleProps = {
	title: string;
	pageInfo?: string;
	pageInfoMessage?: string;
	extra?: ReactNode;
};

export const PageTitle = ({
	title,
	pageInfo,
	pageInfoMessage = 'Sobre esta pantalla',
	extra,
}: PageTitleProps) => {
	const [expanded, setExpanded] = useState(false);

	return (
		<div className='page-title-block'>
			<div className='page-title-row'>
				<h1 className='title-card' style={{ display: 'flex', alignItems: 'center', gap: 8, margin: 0, paddingTop: 0 }}>
					{title}
					{pageInfo && (
						<button
							type='button'
							className='page-info-icon'
							aria-label={expanded ? 'Ocultar información de la pantalla' : 'Mostrar información de la pantalla'}
							aria-expanded={expanded}
							onClick={() => setExpanded((prev) => !prev)}
						>
							{expanded ? <UpOutlined /> : <DownOutlined />}
						</button>
					)}
				</h1>
				{extra}
			</div>
			{pageInfo && expanded && (
				<div className='page-title-info'>
					<PageInfoCard title={pageInfoMessage} description={pageInfo} />
				</div>
			)}
		</div>
	);
};
